<script setup lang="ts">
import { Link } from '@inertiajs/vue3'

import AppLogoIcon from '@/components/AppLogoIcon.vue'
import { portalRootPath } from '@/routes'
</script>

<template>
  <div class="bg-background min-h-screen">
    <header class="border-border border-b">
      <Link :href="portalRootPath()" class="mx-auto flex max-w-2xl items-center gap-3 px-4 py-4">
        <AppLogoIcon class="w-12 h-5" />
        <span>Total Lifestyle Credit</span>
      </Link>
    </header>
    <main class="mx-auto max-w-2xl px-4 py-6 sm:py-8">
      <slot />
    </main>
  </div>
</template>
